import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const NavigationControls = ({ 
  currentQuestion,
  totalQuestions,
  canGoBack,
  canGoNext,
  isLastQuestion,
  onPrevious,
  onNext,
  onComplete,
  loading = false,
  className = ''
}) => {
  const isFirstQuestion = currentQuestion === 1;
  const progressPercentage = (currentQuestion / totalQuestions) * 100;

  return (
    <div className={`bg-card rounded-lg border border-border p-6 ${className}`}>
      <div className="space-y-4">
        {/* Progress Summary */}
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">
            Question {currentQuestion} of {totalQuestions}
          </span>
          <span className="font-medium text-primary">
            {Math.round(progressPercentage)}% Complete
          </span>
        </div>

        {/* Navigation Buttons */}
        <div className="flex items-center justify-between space-x-4">
          {/* Previous Button */}
          <Button
            variant="outline"
            size="default"
            onClick={onPrevious}
            disabled={isFirstQuestion || !canGoBack || loading}
            iconName="ChevronLeft"
            iconPosition="left"
            className="flex-1 sm:flex-none"
          >
            <span className="hidden sm:inline">Previous</span>
            <span className="sm:hidden">Back</span>
          </Button>

          {/* Question Counter */}
          <div className="hidden sm:flex items-center space-x-2 px-4 py-2 bg-muted rounded-lg">
            <Icon name="FileText" size={16} className="text-muted-foreground" />
            <span className="text-sm font-medium text-foreground">
              {currentQuestion}/{totalQuestions}
            </span>
          </div>

          {/* Next/Complete Button */}
          {isLastQuestion ? (
            <Button
              variant="default"
              size="default"
              onClick={onComplete}
              disabled={!canGoNext || loading}
              loading={loading}
              iconName="CheckCircle"
              iconPosition="right"
              className="flex-1 sm:flex-none"
            >
              Complete Assessment
            </Button>
          ) : (
            <Button
              variant="default"
              size="default"
              onClick={onNext}
              disabled={!canGoNext || loading}
              loading={loading}
              iconName="ChevronRight"
              iconPosition="right"
              className="flex-1 sm:flex-none"
            >
              <span className="hidden sm:inline">Next Question</span>
              <span className="sm:hidden">Next</span>
            </Button>
          )}
        </div>

        {/* Help Text */}
        <div className="text-center">
          {!canGoNext ? (
            <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground">
              <Icon name="AlertCircle" size={16} />
              <span>Please answer the current question to continue</span>
            </div>
          ) : isLastQuestion ? (
            <div className="flex items-center justify-center space-x-2 text-sm text-success">
              <Icon name="CheckCircle" size={16} />
              <span>Ready to complete your assessment</span>
            </div>
          ) : (
            <div className="text-sm text-muted-foreground">
              Answer and continue to the next question
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavigationControls;